import { z } from 'zod';
export const AccountStatus = z.enum(['active', 'restricted', 'banned', 'cooling']);
export const AccountRole = z.enum(['production', 'canary']);
/**
 * Account function (strict mutually-exclusive split).
 *   - observer: joins TG groups, ingests messages, never initiates DMs
 *   - sender:   never joined to groups by the platform, only sends outbound
 *
 * Why strict: TG correlates "account joins many groups + DMs strangers" as
 * a bot signal. Keeping the two activities on separate accounts lowers ban
 * risk significantly.
 */
export const AccountPurpose = z.enum(['observer', 'sender']);
export const WarmupPhase = z.enum(['cold', 'warming', 'ready']);
export const LeadStatus = z.enum([
    'detected',
    'queued',
    'contacted',
    'awaiting_reply',
    'replied',
    'assigned',
    'engaging',
    'closed_won',
    'closed_lost',
]);
export const ConfigVersionStatus = z.enum(['draft', 'canary', 'active', 'rolled_back']);
export const OutboxStatus = z.enum(['pending', 'done', 'failed_perm']);
export const SalesRole = z.enum(['sales', 'lead', 'admin']);
export const FilterStage = z.enum(['keyword', 'embedding', 'llm']);
//# sourceMappingURL=enums.js.map